import { useState, useEffect } from "react";

export const usePopupAnimation = (isOpen: boolean) => {
  const [isVisible, setIsVisible] = useState(false);
  const [shouldRender, setShouldRender] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setShouldRender(true);
      // Small delay to ensure DOM is updated before starting animation
      const openTimer = setTimeout(() => setIsVisible(true), 10);
      return () => clearTimeout(openTimer);
    } else {
      setIsVisible(false);
      // Wait for animation to complete before removing from DOM
      const closeTimer = setTimeout(() => setShouldRender(false), 300);
      return () => clearTimeout(closeTimer);
    }
  }, [isOpen]);

  return { isVisible, shouldRender };
};
